export default __webpack_public_path__ + "static/media/star_big.14aaf0c9.svg";